import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComingSoonComponent } from './Coming-soon.component';
import {ComingSoonRoutes}from './coming-soon.routing';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ComingSoonRoutes,
    SharedModule

  ],
  declarations: [ComingSoonComponent]
})
export class ComingSoonModule { }
